import React from 'react';
import cn from 'classnames';

import { DisplayType, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { LinkAsAsset } from '@kaltura-ott/tvpil-shared';

import { IMAGE_PARAM } from 'consts';

import LinkView from '../../../LinkView/LinkView';

import styles from '../../../../Menu.module.scss';

interface Props {
  path: string;
  linkAsAsset: LinkAsAsset;
  subtype?: UIDAPresentationTypeEnum;
}

function LinkViewResolver({ path, linkAsAsset, subtype }: Props) {
  const menuItem = linkAsAsset.data.linkItem;

  if (!menuItem) {
    return null;
  }

  const isItemAsLogo = menuItem.image && menuItem.displayType === DisplayType.imageOnly;
  const isItemAsText = menuItem.displayType === DisplayType.textOnly || menuItem.displayType === DisplayType.text;
  const isItemAsImageAndText = menuItem.image && menuItem.displayType === DisplayType.both;

  if (isItemAsLogo) {
    return (
      <LinkView subtype={subtype} ariaLabel={menuItem.name} path={path} menuItem={linkAsAsset}>
        <img className={cn(styles.logo, styles.onlyLogo)} alt={menuItem.name} src={`${menuItem.image}${IMAGE_PARAM}`} />
      </LinkView>
    );
  }

  if (isItemAsText) {
    return (
      <LinkView subtype={subtype} ariaLabel={menuItem.name} path={path} menuItem={linkAsAsset}>
        <p className={styles.text}>{menuItem.name}</p>
      </LinkView>
    );
  }

  if (isItemAsImageAndText) {
    return (
      <LinkView subtype={subtype} ariaLabel={menuItem.name} path={path} menuItem={linkAsAsset}>
        <div className={styles.name}>{menuItem.name}</div>
        <img className={styles.logo} alt={menuItem.name} src={`${menuItem.image}${IMAGE_PARAM}`} />
      </LinkView>
    );
  }

  return null;
}

export default LinkViewResolver;
